import React, {Component} from 'react';
import _ from 'lodash';
import {OVERVIEW_STATUS, TASK_ACTIONS} from 'utils/constants.js';
import {
    OVERVIEW_ALL_STATUS,
    OVERVIEW_FULL,
    OVERVIEW_NO_ROLE_NO_SELECT,
    OVERVIEW_NO_SELECT
} from '../resizableTable/columnsMap';
import * as reduxSelectors from '../store/application.reducers';
import {connect} from 'react-redux';
import {
    changeActiveCounter,
    filterChanged,
    getCounters,
    getOverviewCounters,
    loadMoreOverview,
    overviewTaskSelect,
    sortingColumnChanged
} from './taskOverview.action';
import {ResizableTable} from '../resizableTable/Table.component';
import {formatDate, formatDateTime} from 'utils/valueFormatter.function';
import * as Api from 'utils/api/api.js';
import AsyncTaskActionExecutor from './AsyncTaskActionExecutor.component';
import {taskAction} from '../mytasks/action/taskAction.action';
import 'reactabular-resizable/style.css';
import './task_overview.scss';
import {userHasAccessRights} from 'utils/accessRights.function';
import translate from '../translations/translations.wrapper.jsx';
import { Button, ButtonType } from "components/common/Button.component";
import { SegmentedControl } from "components/common/SegmentedControl.component";

export class TaskOverview extends Component {

    constructor(props) {
        super();
        this.state = {
            companyDocumentTypes: []
        };
        this.loadData = this.loadData.bind(this);
        this.mapTasks = this.mapTasks.bind(this);
        this.refreshGrid = this.refreshGrid.bind(this);
        this.loadMoreTasks = this.loadMoreTasks.bind(this);
        this.changeCounter = this.changeCounter.bind(this);
        this.selectTasks = this.selectTasks.bind(this);
        this.getColumns = this.getColumns.bind(this);
    }


    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentContextId !== this.props.currentContextId && userHasAccessRights(this.props.userData.userRoles, this.props.location)) {
            this.loadData();
        }
    }

    loadData() {
        Api.getCompanyDocumentTypes(this.props.currentContextId).then(function (response) {
            this.setState({
                companyDocumentTypes: response
            });
        }.bind(this));

        this.props.getCounters();
        this.props.getOverviewCounters(this.props.filters, this.props.activeCounter);
    }

    mapTasks(tasks, selectedTasks) {

        let newTaskList = _.cloneDeep(tasks);
        let taskList = newTaskList.rows;
        newTaskList.rows = taskList ? taskList.map((task, index) => {
            let foundTask = _.findIndex(selectedTasks, (x => x === task.key));
            task.isSelected = foundTask !== -1;
            task.taskActivatedDate = formatDateTime(task.taskActivatedDate);
            task.taskDueDate = formatDate(task.taskDueDate);
            task.processCreatedDate = formatDateTime(task.processCreatedDate);
            task.invoiceDate = formatDate(task.invoiceDate);
            task.dueDate = formatDate(task.dueDate);
            // reactabular needs a unique id for each row
            task.index = index;
            return task;
        }) : [];

        return newTaskList;
    }

    refreshGrid(objfilter) {
        let newFilter = Object.assign({}, this.props.filters, objfilter);
        this.props.getCounters();
        this.props.getOverviewCounters(newFilter, this.props.activeCounter);
    }

    loadMoreTasks(callObject) {
        this.props.loadMoreOverview(callObject, this.props.activeCounter);
    }

    changeCounter(index) {
        this.props.changeActiveCounter(index + 1, this.props.filters);
    }

    selectTasks(column) {
        if (this.props.tasks.rows.length > 0) {
            let selectedTasks = [];
            if (column.length > 0) {
                let tasksIds = this.props.tasks.rows.map((task) => {
                    return task.key;
                });
                selectedTasks = selectedTasks.concat(tasksIds);
            } else {
                selectedTasks = selectedTasks.concat(this.props.tasks.rows[column].key)
            }
            this.props.overviewTaskSelect(selectedTasks);
        }
    }

    getColumns() {
        switch (this.props.activeCounter) {
            case OVERVIEW_STATUS.futureTasks:
                return OVERVIEW_NO_ROLE_NO_SELECT;
            case OVERVIEW_STATUS.completedTasks:
                return OVERVIEW_NO_SELECT;
            case OVERVIEW_STATUS.allTasks:
                return OVERVIEW_ALL_STATUS;
            default:
                return OVERVIEW_FULL;
        }
    }

    render() {

        let {activeCounter, counters, tasks, selectedTasks} = this.props;
        let mappedTasks = this.mapTasks(Object.assign({}, tasks), selectedTasks);
        let columns = this.getColumns();

        let selector_values = Object.assign({}, {"role_select": this.props.userRoles}, {"documentType": this.state.companyDocumentTypes});

        let counterOptions = counters ? Object.keys(counters).map((counter, index) => ({
            key: index,
            isSelected: (index + 1) === activeCounter,
            onClick: this.changeCounter.bind(this, index),
            label: (
                <>
                    {this.props.translate("taskOverview." + counter)}
                    {index < 2 && counters[counter] > 0 &&
                        <span className={"ms-2"}>- {counters[counter]}</span>
                    }
                    {index === 2 && counters[counter] > 0 &&
                        <span className={"ms-2"}>- {counters[counter]}</span>
                    }
                    {index === 3 && counters[counter] > 0 &&
                        <span className={"ms-2"}>- {counters[counter]}</span>
                    }
                </>
            )
        })) : null;

        return (
            <div className="col-md-12 px-0">
                <AsyncTaskActionExecutor translate={this.props.translate} reloadTasks={this.refreshGrid}/>
                <div className="d-flex align-items-center mx-0">
                    <span className="filter_name pull-left float-left mr-24">
                            {this.props.translate("taskOverview.tasks")}
                        </span>

                    {counterOptions &&
                        <SegmentedControl className="float-left" options={counterOptions} />
                    }
                </div>
                <ResizableTable tasks={mappedTasks}
                                defaultColumns={columns}
                                selectedTasks={selectedTasks}
                                activeCounter={activeCounter}
                                loadingStatus={this.props.loadingStatus}
                                selectors={selector_values}
                                sortingLogic={this.props.sortingLogic}
                                filterChanged={this.props.filterChanged}
                                sortingColumnChanged={this.props.sortingColumnChanged}
                                taskSelect={this.selectTasks}
                                translate={this.props.translate}
                                filters={this.props.filters}
                                loadMoreTasks={this.loadMoreTasks}
                                refreshGrid={this.refreshGrid}
                />

                {activeCounter < 4 && this.props.userData.userRoles.systemAdministrator &&
                    <OverviewButtons selectedTaskKeys={this.props.selectedTasks}
                                     translate={this.props.translate}
                                     action={this.props.taskAction}/>
                }
            </div>
        )
    }
}

const withTranslations = translate(TaskOverview);

const mapStateToProps = function (store) {
    return {
        counters: reduxSelectors.getOverviewCounters(store),
        activeCounter: reduxSelectors.getOverviewActiveCounter(store),
        tasks: reduxSelectors.getOverviewTasks(store),
        filters: reduxSelectors.getOverviewFilter(store),
        sortingLogic: reduxSelectors.getOverviewSortingLogic(store),
        userRoles: reduxSelectors.getOverviewUserRoles(store),
        loadingStatus: reduxSelectors.getOverviewLoadingStatus(store),
        selectedTasks: reduxSelectors.getOverviewSelectedTasks(store),
        currentContextId: reduxSelectors.getUsersCurrentContextId(store),
        userData: reduxSelectors.getUsersData(store)
    };
};
const connected = connect(mapStateToProps, {
    getOverviewCounters,
    getCounters,
    changeActiveCounter,
    filterChanged,
    loadMoreOverview,
    sortingColumnChanged,
    overviewTaskSelect,
    taskAction
})(withTranslations);

export default connected;

const OverviewButtons = ({selectedTaskKeys, action, translate, backToMyTasks}) => {

    return (
        <div className="fixed-bottom px-16">
            <div className="d-flex justify-content-end m-8 gap-8 px-2">
                <Button type={ButtonType.PRIMARY}
                        onClick={() => {
                            action(TASK_ACTIONS.REASSIGN, selectedTaskKeys);
                        }}
                        disabled={selectedTaskKeys.length <= 0}
                        text={translate("taskOverview.reassign")}
                />
            </div>
        </div>
    )
};
